import React, { useEffect } from "react";


// const examData = {
//   "positions": [
//     {
//       "lat": 37.27943075229118,
//       "lng": 127.01763998406159
//     },
//     {
//       "lat": 37.55915668706214,
//       "lng": 126.92536526611102
//     },
//     {
//       "lat": 35.13854258261161,
//       "lng": 129.1014781294671
//     },
//     {
//       "lat": 37.55518388656961,
//       "lng": 126.92926237742505
//     },
//     {
//       "lat": 35.20618517638034,
//       "lng": 129.07944301057026
//     },
//     {
//       "lat": 37.561110808242056,
//       "lng": 126.9831268386891
//     },
//     {
//       "lat": 37.86187129655063,
//       "lng": 127.7410250820423
//     },
//     {
//       "lat": 37.47160156778542,
//       "lng": 126.62818064142286
//     },
//     {
//       "lat": 35.10233410927457,
//       "lng": 129.02611815856181
//     },
//     {
//       "lat": 35.10215562270429,
//       "lng": 129.02579793018205
//     },
//     {
//       "lat": 35.475423012251106,
//       "lng": 128.76666923366042
//     },
//     {
//       "lat": 35.93282824693927,
//       "lng": 126.95307628834287
//     },
//     {
//       "lat": 36.33884892276137,
//       "lng": 127.393666019664
//     },
//     {
//       "lat": 37.520412849636,
//       "lng": 126.9742764161581
//     },
//     {
//       "lat": 35.155139675209675,
//       "lng": 129.06154773758374
//     },
//     {
//       "lat": 35.816041994696576,
//       "lng": 127.11046706211324
//     },
//     {
//       "lat": 38.20441110638504,
//       "lng": 128.59038671285234
//     },
//     {
//       "lat": 37.586112739308916,
//       "lng": 127.02949148517999
//     },
//     {
//       "lat": 37.50380641844987,
//       "lng": 127.02130716617751
//     },
//     {
//       "lat": 37.55155704387368,
//       "lng": 126.92161115892036
//     },
//     {
//       "lat": 37.55413060051369,
//       "lng": 126.92207472929526
//     },
//     {
//       "lat": 36.362321615174835,
//       "lng": 127.35000483225389
//     },
//     {
//       "lat": 37.55227862908755,
//       "lng": 126.92280546294998
//     },
//     {
//       "lat": 37.490413948014606,
//       "lng": 127.02079678472444
//     },
//     {
//       "lat": 35.172358507549596,
//       "lng": 126.90545394866643
//     },
//     {
//       "lat": 35.15474103200252,
//       "lng": 129.11827889154455
//     },
//     {
//       "lat": 37.516081250973485,
//       "lng": 127.02369057166361
//     },
//     {
//       "lat": 36.80711722863776,
//       "lng": 127.14020346037576
//     },
//     {
//       "lat": 37.28957415752673,
//       "lng": 127.00103752005424
//     },
//     {
//       "lat": 35.83953896766896,
//       "lng": 128.7566880321854
//     },
//     {
//       "lat": 37.51027412948879,
//       "lng": 127.08227718124704
//     },
//     {
//       "lat": 37.493581783270294,
//       "lng": 126.72541955660554
//     },
//     {
//       "lat": 35.135291862962795,
//       "lng": 129.10060911448775
//     },
//     {
//       "lat": 35.174574933144065,
//       "lng": 126.91389980787773
//     },
//     {
//       "lat": 37.795887691878654,
//       "lng": 127.10660416587146
//     },
//     {
//       "lat": 37.59288687521181,
//       "lng": 126.96560524627377
//     },
//     {
//       "lat": 37.45076411130452,
//       "lng": 127.14593003749792
//     },
//     {
//       "lat": 35.86008337557079,
//       "lng": 127.1263912488061
//     },
//     {
//       "lat": 35.23773491330953,
//       "lng": 129.08371037429578
//     },
//     {
//       "lat": 37.524297321304886,
//       "lng": 127.05018281937049
//     },
//     {
//       "lat": 36.33386658021849,
//       "lng": 127.4461721466889
//     },
//     {
//       "lat": 35.72963747546802,
//       "lng": 128.27079056365005
//     },
//     {
//       "lat": 36.02726828142973,
//       "lng": 129.37257233594056
//     },
//     {
//       "lat": 35.0708030360945,
//       "lng": 129.0593185494088
//     },
//     {
//       "lat": 35.86835862950247,
//       "lng": 128.59755089175871
//     },
//     {
//       "lat": 33.51133264696746,
//       "lng": 126.51852347452322
//     },
//     {
//       "lat": 37.61284289586752,
//       "lng": 127.03120547238589
//     },
//     {
//       "lat": 35.851696038722466,
//       "lng": 128.59092937125666
//     },
//     {
//       "lat": 37.59084695083232,
//       "lng": 127.01872773588882
//     },
//     {
//       "lat": 35.52114874288784,
//       "lng": 129.33573629945764
//     },
//     {
//       "lat": 36.362326407439845,
//       "lng": 127.33577420148076
//     },
//     {
//       "lat": 37.28941189110747,
//       "lng": 127.00446132665141
//     },
//     {
//       "lat": 35.32049801117398,
//       "lng": 129.1810343576788
//     },
//     {
//       "lat": 37.53338631541601,
//       "lng": 127.00615481678061
//     },
//     {
//       "lat": 37.413461468258156,
//       "lng": 126.67735680840826
//     },
//     {
//       "lat": 35.920390371093205,
//       "lng": 128.54411720249956
//     },
//     {
//       "lat": 36.65489374054824,
//       "lng": 127.48374816871991
//     },
//     {
//       "lat": 37.49491987110441,
//       "lng": 127.01493134206048
//     },
//     {
//       "lat": 37.64985695608336,
//       "lng": 127.14496345268074
//     },
//     {
//       "lat": 37.55686770317417,
//       "lng": 127.16927880543041
//     },
//     {
//       "lat": 37.37014007589146,
//       "lng": 127.10614330185591
//     },
//     {
//       "lat": 37.5350236507627,
//       "lng": 126.96157681184789
//     },
//     {
//       "lat": 37.40549630594667,
//       "lng": 126.8980581820004
//     },
//     {
//       "lat": 34.867950544005744,
//       "lng": 128.69069690081176
//     },
//     {
//       "lat": 35.16317059543225,
//       "lng": 128.98452978748048
//     },
//     {
//       "lat": 36.607484825953186,
//       "lng": 127.48520451195111
//     },
//     {
//       "lat": 37.651724785213986,
//       "lng": 126.58306748337554
//     },
//     {
//       "lat": 35.86059690063427,
//       "lng": 128.59193087665244
//     },
//     {
//       "lat": 35.25685847585025,
//       "lng": 128.59912605060455
//     },
//     {
//       "lat": 33.509258155694496,
//       "lng": 126.5109451464813
//     },
//     {
//       "lat": 37.64366155701157,
//       "lng": 126.63255039247507
//     },
//     {
//       "lat": 35.82667262227336,
//       "lng": 127.1030670574823
//     },
//     {
//       "lat": 35.82003554991111,
//       "lng": 127.14810974062483
//     },
//     {
//       "lat": 35.097485195649455,
//       "lng": 128.99486181862338
//     },
//     {
//       "lat": 37.32204249590605,
//       "lng": 127.95591893585816
//     },
//     {
//       "lat": 37.50535127272031,
//       "lng": 127.1047465440526
//     },
//     {
//       "lat": 36.99081407156533,
//       "lng": 127.09338324956647
//     },
//     {
//       "lat": 37.323486640444834,
//       "lng": 127.12285239871076
//     },
//     {
//       "lat": 35.78973089440451,
//       "lng": 127.13644319545601
//     },
//     {
//       "lat": 35.641373953578196,
//       "lng": 129.35463220719618
//     },
//     {
//       "lat": 37.47423127310911,
//       "lng": 126.97625029161996
//     },
//     {
//       "lat": 35.84357192991226,
//       "lng": 128.61143720719716
//     },
//     {
//       "lat": 37.180974984085736,
//       "lng": 128.20294526341132
//     },
//     {
//       "lat": 37.57895718642583,
//       "lng": 126.9316897337244
//     },
//     {
//       "lat": 33.49077253755052,
//       "lng": 126.49314817000993
//     },
//     {
//       "lat": 36.42175925330255,
//       "lng": 128.67409133225766
//     },
//     {
//       "lat": 37.46405540570109,
//       "lng": 126.7153544119173
//     },
//     {
//       "lat": 37.594758776232126,
//       "lng": 127.10099917489818
//     },
//     {
//       "lat": 37.7239966558994,
//       "lng": 127.0478671731854
//     },
//     {
//       "lat": 35.86680171505329,
//       "lng": 128.5923738376741
//     },
//     {
//       "lat": 37.560573727266785,
//       "lng": 126.81239107485251
//     },
//     {
//       "lat": 37.78692224857484,
//       "lng": 126.98966010341789
//     },
//     {
//       "lat": 35.10368644802913,
//       "lng": 129.0206862606022
//     },
//     {
//       "lat": 37.063839948992644,
//       "lng": 127.06856523030079
//     },
//     {
//       "lat": 37.34344643728643,
//       "lng": 127.94382181350932
//     },
//     {
//       "lat": 37.512521267219064,
//       "lng": 127.40054805648133
//     },
//     {
//       "lat": 35.15286653837983,
//       "lng": 126.90419903971498
//     },
//     {
//       "lat": 35.173238445546296,
//       "lng": 129.176082844468
//     },
//     {
//       "lat": 36.082394201323524,
//       "lng": 129.40330471725923
//     },
//     {
//       "lat": 37.51043665598106,
//       "lng": 127.03974070036524
//     },
//     {
//       "lat": 36.627816673285054,
//       "lng": 127.44969866021904
//     },
//     {
//       "lat": 37.59194624756919,
//       "lng": 127.01817545576053
//     },
//     {
//       "lat": 37.387147045560866,
//       "lng": 127.1253365438929
//     },
//     {
//       "lat": 35.89948383848115,
//       "lng": 128.60809550730653
//     },
//     {
//       "lat": 37.555316235235324,
//       "lng": 127.14038447894715
//     },
//     {
//       "lat": 36.09622092762977,
//       "lng": 128.43314679004078
//     },
//     {
//       "lat": 37.582855922985544,
//       "lng": 126.91907857008522
//     },
//     {
//       "lat": 37.516000983841586,
//       "lng": 128.72798872032757
//     },
//     {
//       "lat": 37.48429363675198,
//       "lng": 127.0379630203579
//     },
//     {
//       "lat": 37.54502575965604,
//       "lng": 126.95429338245707
//     },
//     {
//       "lat": 35.236247173046394,
//       "lng": 128.8677618015292
//     },
//     {
//       "lat": 37.40157536691968,
//       "lng": 127.11717457214067
//     },
//     {
//       "lat": 36.95191038001258,
//       "lng": 127.91064040877527
//     },
//     {
//       "lat": 37.491526492971346,
//       "lng": 126.85463749525812
//     },
//     {
//       "lat": 36.124356479753196,
//       "lng": 128.09517052346138
//     },
//     {
//       "lat": 37.15715169307048,
//       "lng": 128.15853461363773
//     },
//     {
//       "lat": 37.5808156608605,
//       "lng": 126.95109705510639
//     },
//     {
//       "lat": 37.46931787249714,
//       "lng": 126.89904775044873
//     },
//     {
//       "lat": 35.52195614910054,
//       "lng": 129.3209904841746
//     },
//     {
//       "lat": 37.58625703195563,
//       "lng": 126.9496035206742
//     },
//     {
//       "lat": 37.28463639199199,
//       "lng": 126.85984474757359
//     },
//     {
//       "lat": 35.534169458631226,
//       "lng": 129.31169021536095
//     },
//     {
//       "lat": 37.553341234194285,
//       "lng": 127.15481222237025
//     },
//     {
//       "lat": 37.62293367990081,
//       "lng": 126.83445005122417
//     },
//     {
//       "lat": 35.5272027005698,
//       "lng": 127.72953798950101
//     },
//     {
//       "lat": 35.180032285898854,
//       "lng": 128.06954509175367
//     }
//   ]
// }

const examData = {
  "positions": [
    {
      "content": '<div class="map_pin"><span class="pin1">0</span><span class="pin2">0</span><span class="pin3">1</span></div>', 
      // "content": '<div style="display: flex;  gap: 10px;  justify-content: center; align-items: center;"><span style="width: 40px;  height: 40px;  border-radius: 50%;  color: white;  font-weight: bold;  display: flex;  align-items: center;  justify-content: center;  font-family: Arial, sans-serif;background-color: #ff9900;">1</span><span style="width: 40px;  height: 40px;  border-radius: 50%;  color: white;  font-weight: bold;  display: flex;  align-items: center;  justify-content: center;  font-family: Arial, sans-serif;background-color: #0099ff;">1</span><span style="width: 40px;  height: 40px;  border-radius: 50%;  color: white;  font-weight: bold;  display: flex;  align-items: center;  justify-content: center;  font-family: Arial, sans-serif;background-color: #ff0000;">1</span></div>', 
      "lat": 37.3154351781114,
      "lng": 126.710989489208
    },
    // {
    //   "content": '<div class="map_pin”><span class="pin1">1</span><span class="pin2">1</span><span class="pin3">1</span></div>', 
    //   // "content": '<div style="display: flex;  gap: 10px;  justify-content: center; align-items: center;"><span style="width: 40px;  height: 40px;  border-radius: 50%;  color: white;  font-weight: bold;  display: flex;  align-items: center;  justify-content: center;  font-family: Arial, sans-serif;background-color: #ff9900;">1</span><span style="width: 40px;  height: 40px;  border-radius: 50%;  color: white;  font-weight: bold;  display: flex;  align-items: center;  justify-content: center;  font-family: Arial, sans-serif;background-color: #0099ff;">1</span><span style="width: 40px;  height: 40px;  border-radius: 50%;  color: white;  font-weight: bold;  display: flex;  align-items: center;  justify-content: center;  font-family: Arial, sans-serif;background-color: #ff0000;">1</span></div>', 
    //   "lat": 37.3154351781114,
    //   "lng": 126.710989489208
    // },
  ]
}
  

export default function KakaoMap() {

  useEffect(() => {
    const onLoadKakaoMap = () => {
      if (!window.kakao || !window.kakao.maps) return;

      const container = document.getElementById("map");
      const options = {
        center: new window.kakao.maps.LatLng(37.3154, 126.7109), // 지도의 중심좌표 
        level: 11 // 지도의 확대 레벨 
      };

      const map = new window.kakao.maps.Map(container, options);

      // 마커 클러스터러를 생성합니다 
      const clusterer = new window.kakao.maps.MarkerClusterer({
          map: map, // 마커들을 클러스터로 관리하고 표시할 지도 객체 
          averageCenter: true, // 클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정 
          minLevel: 10, // 클러스터 할 최소 지도 레벨 
          styles: [
            {
              width: '40px', height: '40px',
              background: '#91caff', color: '#000',
              borderRadius: '50%', lineHeight: '40px'
            },
            {
              width: '50px', height: '50px',
              background: '#5599ff', color: '#fff',
              borderRadius: '50%', lineHeight: '50px'
            },
            {
              width: '60px', height: '60px',
              background: '#0055cc', color: '#fff',
              borderRadius: '50%', lineHeight: '60px'
            }
          ]
      });

      // 데이터를 가져오기 위해 jQuery를 사용합니다
      // 데이터를 가져와 마커를 생성하고 클러스터러 객체에 넘겨줍니다
      //$.get("/download/web/data/chicken.json", function(data) {
          // 데이터에서 좌표 값을 가지고 마커를 표시합니다
          // 마커 클러스터러로 관리할 마커 객체는 생성할 때 지도 객체를 설정하지 않습니다
          const imageSrc = 'https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/marker_red.png'; // 원하는 마커 이미지
          const imageSize = new window.kakao.maps.Size(32, 32); // 이미지 크기
          const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize);

          const markers = (examData.positions).map(function(position, i) {
            // console.log(i,position)
              // return new window.kakao.maps.Marker({
              //     position : new window.kakao.maps.LatLng(position.lat, position.lng),
              //     image: markerImage, // ✅ 커스텀 이미지 지정
              // });
              const marker = new window.kakao.maps.Marker({
                position: new window.kakao.maps.LatLng(position.lat, position.lng),
                image: markerImage,
              });

              // 마커에 표시할 인포윈도우를 생성합니다 
              var infowindow = new window.kakao.maps.InfoWindow({
                  content: position.content // 인포윈도우에 표시할 내용
              });

              // ✅ 클릭 시 링크 이동 및 커스텀 오버레이를 표시
              window.kakao.maps.event.addListener(marker, 'click', function () {
                const url = `/dashboard/sub?bid=${i}`; // 원하는 URL 형식으로 수정 가능
                //window.open(url, '_blank'); // 새 창으로 열기, 또는 location.href = url;
                window.location.href = url;
              });

              // 마커에 mouseover 이벤트와 mouseout 이벤트를 등록합니다
              // 이벤트 리스너로는 클로저를 만들어 등록합니다 
              // for문에서 클로저를 만들어 주지 않으면 마지막 마커에만 이벤트가 등록됩니다
              window.kakao.maps.event.addListener(marker, 'mouseover', makeOverListener(map, marker, infowindow));
              window.kakao.maps.event.addListener(marker, 'mouseout', makeOutListener(infowindow));
              window.kakao.maps.event.addListener(marker, 'wheel', makeOutListener(infowindow));

              // 인포윈도우를 표시하는 클로저를 만드는 함수입니다 
              function makeOverListener(map, marker, infowindow) {
                  return function() {
                      infowindow.open(map, marker);

                      // 말풍선 열릴 때 클래스 추가
                      setTimeout(() => {
                        const pin = document.querySelector('.map_pin');
                        if (pin) {
                          pin.parentElement.classList.add('map_pinbox');
                          pin.parentElement.parentElement.classList.add('map_pinparents');
                        }
                      }, 0);
                  };
              }

              // 인포윈도우를 닫는 클로저를 만드는 함수입니다 
              function makeOutListener(infowindow) {
                  return function() {
                      infowindow.close();
                  };
              }

              return marker;
          });

          // 클러스터러에 마커들을 추가합니다
          clusterer.addMarkers(markers);
      //});

      // const marker = new window.kakao.maps.Marker({
      //   position: options.center,
      //   map: map,
      // });

      // const infowindow = new window.kakao.maps.InfoWindow({
      //   content: "<div style='padding:5px;'>서울 시청</div>",
      // });
      // infowindow.open(map, marker);
    };

    // 스크립트가 이미 로드된 경우
    if (window.kakao && window.kakao.maps) {
      onLoadKakaoMap();
    } else {
      // 로딩 대기 후 실행
      const script = document.createElement("script");
      script.src =
        "https://dapi.kakao.com/v2/maps/sdk.js?appkey=acbc56499e8453a7e6765c2fd79e6e0c&autoload=false&libraries=services,clusterer  ";
      script.onload = () => {
        window.kakao.maps.load(onLoadKakaoMap);
      };
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div>
      <div id="map" style={{ width: "100%", height: "510px" }}></div>
    </div>
  );
}